import { SortDirection, SortLabels } from "./TableColumnHeader.tsx";
import { TableSort } from "./listUrlParams.ts";
import {
  CheckboxListFilter,
  CheckboxListOption,
} from "./Filters/CheckboxListFilter.tsx";
import { NumberRangeFilter } from "./Filters/NumberRangeFilter.tsx";
import { DateRangeFilter } from "./Filters/DateRangeFilter.tsx";
import { isEmptyRange, NumberRange } from "./numberRange.ts";
import { DateRange, isEmptyDateRange } from "./dateRange.ts";

export function sortableColumnProps<Field extends string>({
  field,
  sort,
  onSortChange,
  sortLabels,
}: {
  field: Field;
  sort: TableSort<Field>;
  onSortChange: (sort: TableSort<Field>) => void;
  sortLabels: SortLabels;
}) {
  return {
    sortLabels,
    sortDirection: sort.sortBy === field ? sort.sortDirection : undefined,
    onSort: (sortDirection: SortDirection) =>
      onSortChange({ sortBy: field, sortDirection }),
  };
}

export function checkboxListFilterProps<Value extends string>(
  options: CheckboxListOption<Value>[],
  selected: Value[],
  onApply: (selected: Value[]) => void,
) {
  return {
    isFiltered: selected.length > 0,
    renderFilter: (close: () => void) => (
      <CheckboxListFilter<Value>
        options={options}
        value={selected}
        onApply={onApply}
        close={close}
      />
    ),
  };
}

export function numberRangeFilterProps(
  range: NumberRange,
  onApply: (range: NumberRange) => void,
) {
  return {
    isFiltered: !isEmptyRange(range),
    renderFilter: (close: () => void) => (
      <NumberRangeFilter
        value={range}
        onApply={onApply}
        close={close}
        allowDecimals={false}
      />
    ),
  };
}

export function dateRangeFilterProps(
  range: DateRange,
  onApply: (range: DateRange) => void,
) {
  return {
    isFiltered: !isEmptyDateRange(range),
    renderFilter: (close: () => void) => (
      <DateRangeFilter value={range} onApply={onApply} close={close} />
    ),
  };
}
